import _typeof from 'babel-runtime/helpers/typeof';
import _getIterator from 'babel-runtime/core-js/get-iterator';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import App from './App';
import { router } from './router';
import KeycloakService from './service/keycloak/KeycloakService.js';
import GeneralConfigService from './service/GeneralConfigService.js';
import FormConfigService from './service/FormConfigService.js';
import UserSettingsService from './service/UserSettingsService.js';
import jslogger from './plugins/logger/jslogger';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse';
import Notifications from 'vue-notification';
import VueScrollactive from 'vue-scrollactive';
import MessageTranslations from './messageTranslations';

Vue.use(VTooltip);

Vue.config.productionTip = false;

Vue.filter('translate', function (key, prefix) {
  if (prefix != null) {
    key = prefix + '.' + key;
  }
  var langObj = translationSetup();
  if (key in langObj) {
    return langObj[key];
  }
  return key;
});

Vue.filter('currency', function (num) {
  if (num == null || isNaN(num)) return '-';
  return Number(num).toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
});

Vue.filter('decodeEntity', function (str) {
  var entities = [{ html: '&euro;', char: '€' }, { html: '&eacute;', char: 'é' }];

  var s = str;
  for (var item in entities) {
    var entry = entities[item];
    s = s.replace(entry.html, entry.char);
  }
  return s;
});

Vue.filter('translateApiMessage', function (msg) {
  var translateFilter = Vue.filter('translate');

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(MessageTranslations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var t = _step.value;

      var match = msg.match(t.re);
      if (match !== null) {
        var _ret = function () {
          var params = match.slice(1);

          var translatedMsg = translateFilter(t.key);
          if (!translatedMsg) {
            return {
              v: msg
            };
          }

          params.forEach(function (p, index) {
            translatedMsg = translatedMsg.replace(new RegExp('\\{' + index + '\\}'), p);
          });
          return {
            v: translatedMsg
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return msg;
});

KeycloakService.init().then(function () {
  GeneralConfigService.init();
  FormConfigService.init();
  UserSettingsService.init();
  Vue.use(jslogger);
  Vue.use(Notifications);
  Vue.use(VueScrollactive);
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router: router,
    template: '<App/>',
    components: { App: App }
  });
});

function translationSetup() {
  var userLang = KeycloakService.getLanguage();
  var langObj = require('./language.properties');
  try {
    langObj = require('./language_' + userLang + '.properties');
    return langObj;
  } catch (error) {
    return langObj;
  }
}


// WEBPACK FOOTER //
// ./src/main.js